import { modalController } from '@ionic/vue'
import MdxParameterModal from './mdx-parameter-modal.vue'

export default {
	create(options) {
		return modalController.create({
			...options,

			component: MdxParameterModal,
			cssClass: 'mdx-parameter-modal',
			backdropDismiss: true
		})
	}
}